import Icon from './Icon'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class RowExpander extends Component {
  static propTypes = {
    expanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
  }

  static defaultProps = {
    expanded: false
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.expanded !== this.props.expanded
  }

  render() {
    const classes = classNames('cursor', {
      'row-expander-rotated': this.props.expanded
    })

    return (
      <Icon
        name="chevron-right"
        className={classes}
        onClick={this.props.onClick}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/RowExpander.js